import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule,
} from "vuex-module-decorators";
import store from "@/store";

@Module({
  name: "layout",
  dynamic: true,
  namespaced: true,
  store: store,
})
class Layout extends VuexModule {
  private _cartmini = false;

  get cartmini(): boolean {
    return this._cartmini;
  }

  private _layout = "init";

  get layout(): string {
    return this._layout;
  }

  private _reload = false;

  get reload(): boolean {
    return this._reload;
  }

  private _sidebar = false;

  get sidebar(): boolean {
    return this._sidebar;
  }

  @Action
  setLayout(layout: string) {
    this.SET_LAYOUT(layout);
  }

  @Action
  setReload(reload: boolean) {
    this.SET_RELOAD(reload);
  }

  @Action
  setReloadOn() {
    this.SET_RELOAD(true);
  }

  @Action
  setReloadOff() {
    this.SET_RELOAD(false);
  }

  @Action
  openSidebar(): void {
    this.SET_SIDEBAR(true);
  }

  @Action
  closeSidebar(): void {
    this.SET_SIDEBAR(false);
  }

  @Action({ commit: "SET_CARTMINI" })
  openCartMini(): boolean {
    return true;
  }

  @Action({ commit: "SET_CARTMINI" })
  closeCartMini(): boolean {
    return false;
  }

  @Action({ commit: "SET_CARTMINI" })
  toggleCartMini(): boolean {
    return !this._cartmini;
  }

  @Mutation
  private SET_LAYOUT(name: string) {
    this._layout = name;
  }

  @Mutation
  private SET_RELOAD(reload: boolean) {
    this._reload = reload;
  }

  @Mutation
  private SET_SIDEBAR(bVal: boolean) {
    this._sidebar = bVal;
  }

  @Mutation
  private SET_CARTMINI(bVal: boolean) {
    this._cartmini = bVal;
  }
}

export const LayoutModule = getModule(Layout);
